// @ts-nocheck
import { fetchContactDetails, fetchAccountDetails } from '../api';
import { call, put, all } from 'redux-saga/effects';
import {
  transactionFetched,
  transactionFetchFailed,
} from '../reducer/transactionsSlice';
import {
  availableCardsFailed,
  availableCardsFetched,
} from '../reducer/userSlice';
import { setProvinceCode } from '../reducer/userLocationSlice';

export function* fetchContactDetailsSaga(action) {
  const { accountId, customerId, isRefresh, primaryAccountDetails } =
    action.payload;
  try {
    const response = yield call(
      fetchContactDetails,
      'contact_details',
      accountId,
      customerId,
      isRefresh
    );
    const availableCards = response?.contact?.availableCards || [];
    yield put(
      setProvinceCode(response?.contact?.address?.areaLevelOne?.code ?? null)
    );

    // Fetch card type for each card using another API call
    const cardsWithTypeRest = yield all(
      availableCards.slice(1).map(
        (card) =>
          call(
            fetchAccountDetails,
            'account_details',
            accountId,
            card?.customerId
          ) // Assuming cardId is an identifier for each card
      )
    );

    const cardsWithType = [
      { accountDetail: primaryAccountDetails },
      ...cardsWithTypeRest,
    ];
    // Enrich cards with their respective types
    const enrichedCards = availableCards.map((card, index) => ({
      ...card,
      productExternalCode:
        cardsWithType[index].accountDetail.productExternalCode,
      productName: cardsWithType[index].accountDetail?.productName,
    }));
    yield put(availableCardsFetched(enrichedCards));
  } catch (error) {
    console.log('Error ContactDetails', error);
    yield put(availableCardsFailed());
  }
}
